import type { ProjectStatusColor } from "@/types";

export const STATUS_BAR_COLORS = {
  neutral: "bg-neutral-800",
  info: "bg-info-400",
  warning: "bg-warning-400",
  danger: "bg-danger-600",
  success: "bg-success-400",
  secondary: "bg-accent-400",
} as const;

export const TAG_COLOR_TO_BAR_COLOR: Record<ProjectStatusColor, string> = {
  Neutral: STATUS_BAR_COLORS.neutral,
  Info: STATUS_BAR_COLORS.info,
  Warning: STATUS_BAR_COLORS.warning,
  Danger: STATUS_BAR_COLORS.danger,
  Success: STATUS_BAR_COLORS.success,
  Secondary: STATUS_BAR_COLORS.secondary,
};
